import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { ForgeContent } from "../forgeContent.js";

/**
 * The forge's browse page, showroom layout, after the boxes catalog: the heading with its actions,
 * the sort tabs, then the grid. On phones the actions share a row under the title.
 */
export function ForgeShowroomLayout({ sections }: PageLayoutProps<ForgeContent>) {
  return (
    <Section className="flex flex-col gap-6 pt-6 pb-20 md:gap-8">
      {sections.heading}
      {sections.sort}
      {sections.grid}
    </Section>
  );
}
